/**
 * @description Enum containing routes to all pages rendered by react-router
 */
export enum AllRoutes {
  Home = "/",
  Dashboard = "/dashboard",
  SignIn = "/sign-in",
  Projects = "/projects",
  Hours = "/hours",
}
